import { Fragment } from 'react';

import Views from '../OrgUnitAdminUserViews';
import ViewTemplate from '../../../../components/viewTemplateOmeTeamEntry/ViewTemplate';

import OrgUnitAdminPurchasesWrite from './OrgUnitAdminPurchasesWrite';
import OrgUnitAdminPurchasesReadOnly from './OrgUnitAdminPurchasesReadOnly';

import useOrgUnitAdminPurchases from './UseOrgUnitAdminPurchases';

const OrgUnitAdminPurchases = () => {
  const { oUAdminEntryContextState } = useOrgUnitAdminPurchases();

  return (
    <Fragment>
      <ViewTemplate
        viewName={Views.OME_MEET_SUBMIT}>
        {oUAdminEntryContextState.isReadOnly === false ?
          <OrgUnitAdminPurchasesWrite /> :
          <OrgUnitAdminPurchasesReadOnly />
        }
      </ViewTemplate>
    </Fragment>
  );
};

export default OrgUnitAdminPurchases;